// import React, { useState } from "react";
// import  "./Forgetpassword.scss";
// // import { toastSuccess, toastError } from "@/config/ToastModal";
// import { Form, Button, Modal, FloatingLabel } from "react-bootstrap";
// import { ForgetMailServices } from "../../services/auth";
// import { useNavigate } from "react-router-dom";
// import { toastError, toastSuccess } from "../../config/ToastModal";

// function Forgotpassword() {
//   const router = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const [email, setEmail] = useState(null);

//   const [error, setError] = useState(false);

//   const handleChange = async (e) => {
//     setEmail(e.target.value);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setLoading(true);
//     if (email?.length > 0) {
//       const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

//       if (emailPattern.test(email)) {
//         const datas = {
//           email: email,
//         };

//         const { status, message } = await ForgetMailServices(datas);

//         if (status) {
//           toastSuccess(
//             "Password reset link has been sent to your email successfully!"
//           );
//           setTimeout(() => {
//             setLoading(false);
//             router("/");
//           }, 800);
//         } else {
//           toastError(message);
//           setLoading(false);
//         }
//       } else {
//         toastError("Please Enter Valid Email Id");
//         setLoading(false);
//       }
//     } else {
//       setError(true);
//       setLoading(false);
//     }
//   };

//   const backButton = () => {
//     router("/");
//   };
//   return (
//     <div className={"mainforgetpassword"}>
//       <div className={"insideforget"}>
//         <div className="fw-bold fs-3">Reset Password</div>
//         <div>
//           <div className="form-group mb-4 mt-4">
//             <label>
//               Email ID <span className="text-danger">*</span>
//             </label>
//             <Form.Control
//               type="text"
//               name="email"
//               placeholder="Enter Your Email ID"
//               onChange={handleChange}
//               value={email}
//             />
//             {error && email?.length <= 0 ? (
//               <div className="text-danger">Email Id is required</div>
//             ) : null}
//           </div>
//         </div>
//         <div className="mt-4 mb-4">
//           <button
//             onClick={handleSubmit}
//             className="theme-btn btn-style-one w-100"
//           >
//             {loading ? "...Loading" : "Send Email"}
//           </button>
//           <div
//             onClick={backButton}
//             className="text-danger mt-3 mb-4 text-center fw-bold cursor"
//           >
//             Back Login
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Forgotpassword;

import React, { useState } from "react";
import "./Forgetpassword.scss";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import { ForgetMailServices } from "../../services/auth";
import { useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "../../config/ToastModal";

function Forgotpassword() {
  const router = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (email?.length > 0) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (emailPattern.test(email)) {
        const { status, message } = await ForgetMailServices({ email });

        if (status) {
          toastSuccess("Password reset link has been sent to your email!");
          setTimeout(() => {
            setLoading(false);
            router("/");
          }, 800);
        } else {
          toastError(message);
          setLoading(false);
        }
      } else {
        toastError("Please Enter a Valid Email Id");
        setLoading(false);
      }
    } else {
      setError(true);
      setLoading(false);
    }
  };

  const backButton = () => {
    router("/");
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center min-vh-100 bg-light"
    >
      <Row className="w-100 justify-content-center">
        <Col
          xs={11}
          sm={8}
          md={6}
          lg={4}
          className="p-4 bg-white rounded shadow"
        >
          <div className="text-center fw-bold fs-3 mb-4">Reset Password</div>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label>
                Email ID <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter Your Email ID"
                onChange={handleChange}
                value={email}
              />
              {error && email?.length <= 0 && (
                <div className="text-danger mt-1">Email Id is required</div>
              )}
            </Form.Group>

            <button
              // type="submit"
              className="w-100 theme-btn btn-style-one"
              disabled={loading}
            >
              {loading ? "...Loading" : "Send Email"}
            </button>
          </Form>

          <div
            onClick={backButton}
            className="text-danger mt-4 text-center fw-bold"
            style={{ cursor: "pointer" }}
          >
            Back to Login
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Forgotpassword;
